import { WebLinks } from '../../components/web-links/web-links.component';
import style from './header.module.scss';

export const Header: React.FC = () => {
    return (
        <div className={style.wrapper}>
            <WebLinks />
        </div>
    );
};
